// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__JgyQe","rotate":"Spinner_rotate__OaauR"};